var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 23.1094C1.6875 23.8906 2.875 23.875 3.625 23.1094L6.39062 20.3594C17.0469 9.6875 21.1406 5.90625 22.3281 7.09375C23.2656 8.01562 20.6875 10.875 16.3125 16.0156C12.0469 21.0469 6.92188 26.7344 10.5781 30.4062C13.8594 33.7188 18.9531 29.4688 22.9844 25.5938C26.6875 22.0469 28.1094 20.8281 28.3438 21.0469C28.5781 21.2656 27.75 22.0312 26.5469 24.1094C25.0625 26.6875 23.0312 30.125 25.2656 32.375C26.9844 34.0938 29.7031 33.2188 32.9219 29.9688C33.7812 29.1094 33.8281 27.9375 33.0469 27.1719C32.2969 26.4219 31.1562 26.4219 30.375 27.1562C28.9688 28.4688 27.8281 29.5312 27.75 29.4688C27.7188 29.4688 28.6719 28 29.7344 26.2344C32.125 22.25 32.6875 20.0156 31.0781 18.4219C29.0156 16.3594 25.7656 17.6875 20.2969 22.8438C16.25 26.6719 13.9219 28.3281 13.2656 27.6875C12.5312 26.9531 14.3438 24.0469 19.1719 18.4844C25.8906 10.7188 27.7969 7.17188 25.0156 4.40625C21.5156 0.921875 17.9688 3.40625 3.70312 17.6719L0.953125 20.4219C0.203125 21.1719 0.203125 22.3438 0.9375 23.1094Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.a126d9ac75bc4ea29c418bf264ce6e95.svg";
export { ForwardRef as ReactComponent };